
<div *ngIf="!isChecked"></div>
<div *ngIf="isChecked">
    <app-login *ngIf="!hiddenSidebar"></app-login>
<app-sidenav *ngIf="hiddenSidebar"></app-sidenav>
</div>

